import { RootState } from "../Store";

export const selectProducts = (state: RootState) => state.product.products;
